import { emailRegExp } from '../constants';

export function isValidEmail(input: string): boolean {
  if (input.length > 320) {
    return false;
  }

  return emailRegExp.test(input);
}
